import * as React from 'react';
export const LKSvg = React.forwardRef(function LKSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd',
      },
      /*#__PURE__*/ React.createElement(
        'g',
        null,
        /*#__PURE__*/ React.createElement('path', {
          fill: '#F4B32E',
          fillRule: 'nonzero',
          d: 'M2 2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2Z',
        }),
        /*#__PURE__*/ React.createElement('path', {
          fill: '#E37C4C',
          d: 'M3 3h2v10H3z',
        }),
        /*#__PURE__*/ React.createElement('path', {
          fill: '#B1372F',
          d: 'M6 3h8a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H6V3Zm1 1v1h1V4H7Zm6 0v1h1V4h-1Zm-6 7v1h1v-1H7Zm6 0v1h1v-1h-1ZM8 7v2h5V7H8Z',
        }),
      ),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#159570',
        d: 'M2 3h1v10H2a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1Z',
      }),
    ),
  );
});
LKSvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
};
export var LK = {
  category: 'flag',
  colorable: false,
  name: 'LK',
  svg: LKSvg,
};
